<template>
    <div class="parent-survey-card-main-container w-100" :class="customClass">
        <div class="parent-survey-card d-flex w-100 px-3 py-2 align-items-center">
            <div class="parent-survey-card__content d-flex flex-column h-100 align-self-start">
                <div class="font-weight-bold h5">
                    {{survey.name}}
                </div>
                <div>
                    {{survey.description}}
                </div>
            </div>
            <button @click="()=>openLink(survey.survey_link)" class="d-flex align-items-center justify-content-center py-2 px-2 ml-2">
                <div class="d-none d-sm-flex">
                    Start Survey
                </div>
                <i class="material-icons ml-0 ml-sm-2">
                open_in_new
                </i>    
            </button>
        </div>
    </div>
</template>

<script>

export default ({
    components: {
        
    },
    props:{
        survey:{
            type:Object,
            default: ()=>{}
        },
        customClass:String
    },
    data() {
        return {

        }
    },
    methods: {
        openLink(url){
            window.open(url, '_blank').focus();
        }
    }
})
</script>

<style scope lang="scss">
.parent-survey-card-main-container{
    .parent-survey-card{
        height: min-content;
        min-height: 5.688rem;
        background-color: #F5F5F5;
        box-shadow: 0px 3px 6px #0000001A;
        border-radius: 4px;
        -webkit-transition: background-color 0.2s ease-in-out;
        -moz-transition: background-color 0.2s ease-in-out;
        -o-transition: background-color 0.2s ease-in-out;
        transition: background-color 0.2s ease-in-out;

        .parent-survey-card__content{
            flex: 1;
        }

        button{
            background: #E9ECEF 0% 0% no-repeat padding-box;
            border: 1px solid #CED4DA;
            border-radius: 4px;

            *{
                color: #6C757D !important;
            }

            i{
                font-size: 13px;
            }
        }
    }
    
    .parent-survey-card:hover{
    background-color: #E9ECEF;

  }
}
</style>
